import { render, staticRenderFns } from "./card-review-detail-modal.vue?vue&type=template&id=1ee87330&scoped=true"
import script from "./card-review-detail-modal.vue?vue&type=script&lang=js"
export * from "./card-review-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./card-review-detail-modal.vue?vue&type=style&index=0&id=1ee87330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee87330",
  null
  
)

export default component.exports